import { useSelector } from "react-redux";
import { AppStore } from "..";
import { Fetchable, isFetchableSuccess } from "../common/fetchable/helpers";
import { AuthDTO } from "./models/dto";

export const useIsImpersonation = () => {
  const login = useSelector<AppStore, Fetchable<AuthDTO.Responses.Login.T>>(
    (store) => store.auth.login
  );
  return isFetchableSuccess(login) && !!login.data.accessToken.originalUser?.token;
};
